<template>
  <form id="vehicleTypeForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('description') }"
    >
      <label for="description">{{ $t("description") }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="vehicleType.TPV_DSC"
        v-validate="'required'"
      />

      <small v-show="errors.has('description')" class="form-text">
        {{ errors.first("description") }}
      </small>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors.has('code') }"
    >
      <label for="code">{{ $t("code") }}</label>
      <input
        type="text"
        id="code"
        name="code"
        class="form-control"
        :placeholder="$t('ph_code')"
        v-model="vehicleType.TPV_COD"
        v-validate="'required'"
      />

      <small v-show="errors.has('code')" class="form-text">
        {{ errors.first("code") }}
      </small>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";

export default {
  name: "ArenaVehicleTypeForm",
  components: {
    LoaderButton,
  },

  props: {
    vehicleType: {
      type: Object,
      default: () => ({
        id: undefined,
        TPV_DSC: "",
        TPV_COD: ""
      }),
    },
  },

  methods: {
    ...mapActions("arena", ["createVehicleType", "editVehicleType"]),

    async onClick(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id, ...rest } = this.vehicleType;

      const result = id
        ? await this.editVehicleType({ id, data: rest })
        : await this.createVehicleType(rest);

      if (result) {
        this.$router.push({ name: "listarenavehicletype" });
      }
    },
  }
};
</script>
